const gigReviewContests = [
	{
		path: '/jobs/gig-review-contests/list',
		name: 'jobs-gig-review-contests-list',
		component: () => import('@/views/jobs/gig-review-contests/list.vue'),
		meta: { layout: 'content', module: 'MGJ,gigs' },
	},
]

export default gigReviewContests
